export const ExportActions = {
  AuditLog: "Audit Log",
  CaseInformation: "Case Information",
  StatusReport: "Status Report",
};

export const DocumentExportAction = "Documents";

export const PositionExportActions = {
  PositionInformation: "Position Information",
  ScreeningStatus: "Screening Status",
  FatcaCrs: "FATCA/CRS",
};

export type KeyOfExportActions = keyof typeof ExportActions;
export type KeyOfDocumentExportAction = typeof DocumentExportAction;
export type KeyOfPositionExportActions = keyof typeof PositionExportActions;
